import { Alert, Button, Modal } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

/**
 * Modal para confirmar cancelamento de assinatura
 */
export const CancelSubscriptionModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  isLoading,
  planName 
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FaExclamationTriangle className="text-warning me-2" />
          Cancelar Assinatura
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <Alert variant="warning">
          <strong>Atenção!</strong> Esta ação não pode ser desfeita.
        </Alert>
        
        <p>Tem certeza que deseja cancelar sua assinatura do plano <strong>{planName}</strong>?</p>
        
        <p className="text-muted mb-0">
          Após o cancelamento:
        </p>
        <ul className="text-muted">
          <li>Você voltará para o plano FREE</li>
          <li>Perderá acesso aos recursos premium</li>
          <li>Seus dados serão mantidos</li>
          <li>O cancelamento será efetivado ao final do período já pago</li>
        </ul>
      </Modal.Body>
      
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onHide}
          disabled={isLoading}
        >
          Não, manter assinatura
        </Button>
        <Button 
          variant="danger" 
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? 'Cancelando...' : 'Sim, cancelar assinatura'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
